import { render, staticRenderFns } from "./ApprovalRequest.vue?vue&type=template&id=c17348aa&scoped=true"
import script from "./ApprovalRequest.vue?vue&type=script&lang=js"
export * from "./ApprovalRequest.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRequest.vue?vue&type=style&index=0&id=c17348aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17348aa",
  null
  
)

export default component.exports